import './index.scss'
$("header").addClass("head1");
$("#nav3").addClass("active");